/* NEW: UI_REVAMP */
export const getMinBetAmount = (getGame, gameId) => {
	const found = getGame.data?.find((g) => g.id === gameId);
	return found?.minBetAmount || 1;
};
